const s4 = () =>
  Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);

export const getUuid = () => `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;

export const randomTagIdSuffix = (quartetsNumber = 2) =>
  `_${[...Array(quartetsNumber).fill(null)].map(() => s4()).join('')}`;
